import { EditorState, convertToRaw, ContentState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';

export const convertHtmlToEditorState = value => {
  const contentBlock = htmlToDraft(value.replace(/<(\/)?b>/g, '<$1strong>'));

  const contentState = ContentState.createFromBlockArray(
    contentBlock.contentBlocks,
    null
  );
  return EditorState.createWithContent(contentState);
};

export const convertEditorStateToHtml = value => {
  if (value) {
    const contentState = value.getCurrentContent();
    if (!contentState.hasText()) {
      return '';
    }
    return draftToHtml(convertToRaw(contentState));
  }

  return '';
};
